import routes from './Modules/routes';

const loaderRoutes = {
  load: async (client) => {
    return routes.getRoutes(client);
  }
}

export default loaderRoutes;
